import { axiosPost } from "./ajaxServices";
import {
  urlGetBuyerApplicationList,
  urlGetBuyerApplicationDetail,
  urlApproveBuyerApplication,
  urlRejectBuyerApplication,
  urlSuspendBuyer,
  urlReactivateBuyer,
  urlUpdateBuyer,
  urlGetPriceTierList,
  urlCreatePriceTier,
  urlUpdatePriceTier,
  urlDeletePriceTier,
} from "./CONSTANTS";

const config = { headers: { "content-type": "multipart/form-data" } };

export const apiGetBuyerApplicationList = (currentPage, pageSize, startDate, endDate, status = "", search = "") => {
  const url = urlGetBuyerApplicationList;
  var formData = new FormData();
  formData.append("currentPage", currentPage);
  formData.append("pageSize", pageSize);
  formData.append("startDate", startDate);
  formData.append("endDate", endDate);
  formData.append("status", status);
  formData.append("search", search);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const apiGetBuyerApplicationDetail = (id) => {
  const url = urlGetBuyerApplicationDetail;
  var formData = new FormData();
  formData.append("id", id);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const apiApproveBuyerApplication = (id, priceTierId, paymentTerms, adminNotes) => {
  const url = urlApproveBuyerApplication;
  var formData = new FormData();
  formData.append("id", id);
  formData.append("price_tier_id", priceTierId ?? "");
  formData.append("payment_terms", paymentTerms ?? "");
  formData.append("admin_notes", adminNotes ?? "");
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const apiRejectBuyerApplication = (id, adminNotes) => {
  const url = urlRejectBuyerApplication;
  var formData = new FormData();
  formData.append("id", id);
  formData.append("admin_notes", adminNotes ?? "");
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const apiSuspendBuyer = (id, adminNotes) => {
  const url = urlSuspendBuyer;
  var formData = new FormData();
  formData.append("id", id);
  if (adminNotes !== undefined) formData.append("admin_notes", adminNotes ?? "");
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const apiReactivateBuyer = (id) => {
  const url = urlReactivateBuyer;
  var formData = new FormData();
  formData.append("id", id);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const apiUpdateBuyer = (id, priceTierId, paymentTerms, adminNotes) => {
  const url = urlUpdateBuyer;
  var formData = new FormData();
  formData.append("id", id);
  if (priceTierId !== undefined) formData.append("price_tier_id", priceTierId ?? "");
  if (paymentTerms !== undefined) formData.append("payment_terms", paymentTerms ?? "");
  if (adminNotes !== undefined) formData.append("admin_notes", adminNotes ?? "");
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const apiGetPriceTierList = () => {
  const url = urlGetPriceTierList;
  var formData = new FormData();
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const apiCreatePriceTier = (data) => {
  const url = urlCreatePriceTier;
  var formData = new FormData();
  formData.append("name", data.name);
  formData.append("discount_percent", data.discount_percent);
  formData.append("default_payment_terms", data.default_payment_terms || "");
  formData.append("status", data.status ?? "1");
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const apiUpdatePriceTier = (data) => {
  const url = urlUpdatePriceTier;
  var formData = new FormData();
  formData.append("id", data.id);
  formData.append("name", data.name);
  formData.append("discount_percent", data.discount_percent);
  formData.append("default_payment_terms", data.default_payment_terms || "");
  formData.append("status", data.status ?? "1");
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const apiDeletePriceTier = (id) => {
  const url = urlDeletePriceTier;
  var formData = new FormData();
  formData.append("id", id);
  return new Promise((resolve, reject) => {
    axiosPost(url, formData, config)
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};
